import { SpecialSymbolType } from '@/containers/symbols/SpecialSymbolType'
import { ReelsUtil } from '@/managers/reels/ReelsUtil'
import { IInitResponse, ISpinResponse, SymbolData } from '@/modules'
import GameSignals from '@/signals/GameSignals'
import { Model } from '@/model/Model'

export class ReelsManager {
    private _errorStopReels: SymbolData[][]
    private _model: Model

    public constructor(model: Model) {
        this._model = model

        GameSignals.init.connect(this.onInitData)
        GameSignals.stopSpin.connect(this.onStopSpin)

        GameSignals.serverError.connect(this.onServerError)
        GameSignals.realityCheck.connect(this.onServerError)
        GameSignals.sessionTimeout.connect(this.onServerError)
        GameSignals.errorConnection.connect(this.onServerError)
    }

    private onInitData = (_data: IInitResponse) => {
        const grid = this._model.initialSlotGrid
        const reels: number[][] = ReelsUtil.parseIndexes(grid)
        this._errorStopReels = grid

        if (reels == null) {
            console.error('ReelsManager: no reels data in init response')
            return
        }

        GameSignals.createReels.emit({
            originalGrid: grid,
            reels,
        })
    }

    private onStopSpin = (data: ISpinResponse) => {
        const reels: number[][] = ReelsUtil.parseIndexes(data.slot_grid[0])
        const roundState = this._model.roundState
        const scatterReels: number[] = []
        const anticipationIndices: number[] = []
        const neededScattersCount: number = roundState.isFreeSpins ? 2 : 3

        this._errorStopReels = data.slot_grid[0]

        if (reels == null) {
            console.error('ReelsManager: no reels data in spin response')
            return
        }

        for (let reel = 0; reel < reels.length - 1; reel++) {
            for (const symbolIndex of reels[reel]) {
                if (symbolIndex === SpecialSymbolType.SCATTER) {
                    scatterReels.push(reel)
                }
            }
        }

        if (scatterReels.length >= neededScattersCount) {
            reels.forEach((reel: number[], index: number) => {
                if (index > scatterReels[neededScattersCount - 1]) {
                    anticipationIndices.push(index)
                }
            })
        }

        GameSignals.stoppingReels.emit({
            originalGrid: data.slot_grid[0],
            anticipationIndices: [], //Facade.isTurboSpin ? [] : anticipationIndices, // removing anticipation logic in initial spin
            reels,
        })
    }

    private onServerError = () => {
        if (this._errorStopReels == null) {
            return
        }

        const reels: number[][] = ReelsUtil.parseIndexes(this._errorStopReels)

        GameSignals.errorStop.emit({
            originalGrid: this._errorStopReels,
            anticipationIndices: [],
            reels,
        })
    }
}
